import * as LucideIcons from "lucide-react";
import { useState } from "react";
import { useInput } from "ra-core";
import { X } from "lucide-react";

import { Button } from "@/components/ui/button";
import { Popover, PopoverContent, PopoverTrigger } from "@/components/ui/popover";

const STAGE_ICONS = [
  "Target",
  "Handshake",
  "Trophy",
  "Star",
  "Zap",
  "TrendingUp",
  "Wallet",
  "DollarSign",
  "Briefcase",
  "Package",
  "FileText",
  "ClipboardList",
  "Users",
  "Building2",
  "Phone",
  "Mail",
  "Calendar",
  "Clock",
  "CheckCircle2",
  "XCircle",
  "AlertCircle",
  "Flame",
  "Rocket",
  "ArrowRight",
  "ThumbsUp",
  "Tag",
  "Flag",
  "Send",
  "Megaphone",
  "Lightbulb",
];

export const StageIconPicker = ({ source }: { source: string }) => {
  const [open, setOpen] = useState(false);
  const { field } = useInput({ source });
  const CurrentIcon =
    field.value
      ? (LucideIcons as Record<string, LucideIcons.LucideIcon>)[field.value]
      : null;

  return (
    <Popover open={open} onOpenChange={setOpen}>
      <PopoverTrigger asChild>
        <Button
          type="button"
          variant="outline"
          size="icon"
          className="h-9 w-9 shrink-0"
          title={field.value || "Выбрать иконку"}
        >
          {CurrentIcon ? (
            <CurrentIcon className="h-4 w-4" />
          ) : (
            <span className="text-[10px] text-muted-foreground">ico</span>
          )}
        </Button>
      </PopoverTrigger>
      <PopoverContent className="w-64 p-3" side="left" align="start">
        <div className="flex items-center justify-between mb-2">
          <span className="text-sm font-medium">Иконка этапа</span>
          {field.value && (
            <Button
              type="button"
              variant="ghost"
              size="icon"
              className="h-6 w-6"
              onClick={() => {
                field.onChange("");
                setOpen(false);
              }}
            >
              <X className="h-3 w-3" />
            </Button>
          )}
        </div>
        <div className="grid grid-cols-6 gap-1">
          {STAGE_ICONS.map((iconName) => {
            const Icon = (
              LucideIcons as Record<string, LucideIcons.LucideIcon>
            )[iconName];
            if (!Icon) return null;
            const isSelected = field.value === iconName;
            return (
              <Button
                key={iconName}
                type="button"
                variant={isSelected ? "default" : "ghost"}
                size="icon"
                className="h-9 w-9"
                title={iconName}
                onClick={() => {
                  field.onChange(iconName);
                  setOpen(false);
                }}
              >
                <Icon className="h-4 w-4" />
              </Button>
            );
          })}
        </div>
      </PopoverContent>
    </Popover>
  );
};
